import { InputAdornment } from '@mui/material'
import { useBoolean } from 'lib/hooks'
import { forwardRef } from 'react'

import { TextField, TextFieldProps } from '../text-field'
import { ToggleVisibilityButton } from './toggle-visibility-button'

export const PasswordTextField = forwardRef<HTMLInputElement, TextFieldProps>(
  (props, ref) => {
    const isVisible = useBoolean()

    return (
      <TextField
        {...props}
        ref={ref}
        type={isVisible.isTrue ? 'text' : 'password'}
        endAdornment={
          <InputAdornment position="end">
            <ToggleVisibilityButton
              isVisible={isVisible.isTrue}
              onClick={isVisible.toggle}
            />
          </InputAdornment>
        }
      />
    )
  },
)
